import ReactDOM from "react-dom";

const NotificationPortal = ({ children }) => {
  const portalRoot = document.getElementById("notification-root");
  return ReactDOM.createPortal(children, portalRoot);
};

export default NotificationPortal;
